import { Route, Routes, Navigate } from "react-router-dom";
import DonatePage from "./pages/DonatePage";

export default function App() {
  return (
    <Routes>
      <Route path="/donate" element={<DonatePage />} />
      <Route path="*" element={<Navigate to="/donate" replace />} />
    </Routes>
  );
}
